<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.5 19.25V13.673L10.423 12L3.5 10.327V4.75L20.7115 12L3.5 19.25Z" fill="currentColor"/>
</svg>
